import { useQuery } from "@apollo/client";
import { TRENDING_DATA_BY_PRODUCTS_QUERY } from "../../../../../legacy/queries/MI";
import {
  TrendingDataMetricOption,
  TrendingDataSegmentOption,
  TrendingDataVariables,
  TrendingDataPayload,
} from "../../../../../legacy/types/companySearch/MI";
import { CompanyFilter } from "../../../../../legacy/types/companyFilter";
import { COMPANY_SEARCH_CLIENT } from "../../../../../utils/consts";
import { useWorkspaceStore } from "../../../../../store/workspace/WorkspaceStore";

export interface ProductTimeSeriesData {
  productId: number;
  hits: number;
  monthStartDate: string;
}

interface Options {
  ids: number[];
  localizeInstalls: boolean;
  companyFilters?: CompanyFilter;
  lookBackYears?: number;
}

export function useProductTrendingData(options: Options) {
  const workspaceWhitespace = useWorkspaceStore(
    (state) => state.draft?.configuration?.whitespace
  );

  const { data, loading } = useQuery<
    TrendingDataPayload,
    TrendingDataVariables
  >(TRENDING_DATA_BY_PRODUCTS_QUERY, {
    variables: {
      companyFilters: options.companyFilters,
      productIds: options.ids,
      lookBackYears: options.lookBackYears,
      localizeInstalls: options.localizeInstalls,
      metric: TrendingDataMetricOption.FirstVerified,
      period: TrendingDataSegmentOption.Quarter,
      companyMatchFile:
        options.companyFilters?.opportunityType &&
        workspaceWhitespace?.fileId &&
        workspaceWhitespace?.lastMatched
          ? workspaceWhitespace
          : undefined,
    },
    skip: options.ids.length === 0,
    context: {
      clientName: COMPANY_SEARCH_CLIENT,
    },
  });

  return {
    loading,
    marketTimeSeriesProductBreakdown:
      data?.marketTimeSeriesProductBreakdown || [],
  };
}
